<template>
  <v-flex
    id="packsContent"
    class="question"
  >
    <h2 class="header">
      {{ $t('gift_giving_report.menu.part_1.5') }}
    </h2>
    <ul class="questions-list">
      <li v-if="giftGivingReportQuestions.hasOwnProperty('key_needs')">
        <p
          class="header"
          :class="{ required: giftGivingReportQuestions.key_needs.required }"
        >
          {{ giftGivingReportQuestions.key_needs.label }}
        </p>
        <ConfirmButtons
          v-model="isPackCorrespondsToNeeds"
          v-validate="{ required: giftGivingReportQuestions.key_needs.required }"
          string
          :error-messages="errors.collect('isPackCorrespondsToNeeds')"
          :data-vv-as="' '"
          :data-vv-name="'isPackCorrespondsToNeeds'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          isPackCorrespondsToNeeds === 'no' &&
            giftGivingReportQuestions.hasOwnProperty('key_needs_description')
        "
        class="mt-3"
      >
        <p
          class="header custom lA"
          :class="{ required: giftGivingReportQuestions.key_needs_description.required }"
        >
          {{ giftGivingReportQuestions.key_needs_description.label }}
        </p>
        <v-textarea
          v-model="wasAbsent"
          v-validate="{
            ...regularLongText(giftGivingReportQuestions.key_needs_description.required, MAX_LONG_FIELD_LENGTH)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('wasAbsent')"
          :data-vv-as="' '"
          :data-vv-name="'wasAbsent'"
          :required="giftGivingReportQuestions.key_needs_description.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="giftGivingReportQuestions.hasOwnProperty('quality')"
        class="mt-3"
      >
        <p
          class="header"
          :class="{ required: giftGivingReportQuestions.quality.required }"
        >
          {{ giftGivingReportQuestions.quality.label }}
        </p>
        <v-radio-group
          v-model="packQuality"
          v-validate="{ required: giftGivingReportQuestions.quality.required }"
          :error-messages="errors.collect('packQuality')"
          :data-vv-as="' '"
          :data-vv-name="'packQuality'"
          :disabled="readOnly"
        >
          <v-radio
            v-for="(item, index) in qualityOptions"
            :key="index"
            :label="item.description"
            :value="item.id"
            :disabled="readOnly"
          />
        </v-radio-group>
      </li>
      <li
        v-if="giftGivingReportQuestions.hasOwnProperty('quality_description')"
        class="mt-3"
      >
        <p
          class="header"
          :class="{ required: giftGivingReportQuestions.quality_description.required }"
        >
          {{ giftGivingReportQuestions.quality_description.label }}
        </p>
        <v-textarea
          v-model="packQualityArguments"
          v-validate="{
            ...regularLongText(giftGivingReportQuestions.quality_description.required, MAX_LONG_FIELD_LENGTH)
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('packQualityArguments')"
          :data-vv-as="' '"
          :data-vv-name="'packQualityArguments'"
          :required="giftGivingReportQuestions.quality_description.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="giftGivingReportQuestions.hasOwnProperty('content')"
        class="mt-3"
      >
        <p
          class="header"
          :class="{ required: giftGivingReportQuestions.content.required }"
        >
          {{ giftGivingReportQuestions.content.label }}
        </p>
        <v-textarea
          v-model="packItems"
          v-validate="{ ...regularLongText(giftGivingReportQuestions.content.required, MAX_LONG_FIELD_LENGTH) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('packItems')"
          :data-vv-as="' '"
          :data-vv-name="'packItems'"
          :required="giftGivingReportQuestions.content.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="giftGivingReportQuestions.hasOwnProperty('immaterial_content')"
        class="mt-3"
      >
        <p
          class="header"
          :class="{ required: giftGivingReportQuestions.immaterial_content.required }"
        >
          {{ giftGivingReportQuestions.immaterial_content.label }}
        </p>
        <ConfirmButtons
          v-model="wereIntangibleNeeds"
          v-validate="{ required: giftGivingReportQuestions.immaterial_content.required }"
          string
          :error-messages="errors.collect('wereIntangibleNeeds')"
          :data-vv-as="' '"
          :data-vv-name="'wereIntangibleNeeds'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          wereIntangibleNeeds === 'yes' &&
            giftGivingReportQuestions.hasOwnProperty('immaterial_content_description')
        "
        class="mt-3"
      >
        <p
          class="header custom lA"
          :class="{ required: giftGivingReportQuestions.immaterial_content_description.required }"
        >
          {{ giftGivingReportQuestions.immaterial_content_description.label }}
        </p>
        <v-textarea
          v-model="describeIntangibleNeeds"
          v-validate="{
            ...regularLongText(
              giftGivingReportQuestions.immaterial_content_description.required, MAX_LONG_FIELD_LENGTH
            )
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('describeIntangibleNeeds')"
          :data-vv-as="' '"
          :data-vv-name="'describeIntangibleNeeds'"
          :required="giftGivingReportQuestions.immaterial_content_description.required"
          auto-grow
          :disabled="readOnly"
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import { FIELD_LENGTH } from '@/constants/validationRules';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getPacksContent',
    mutationType: 'giftGivingReport/updatePacksContent'
});

export default {
    name: 'PacksContent',
    components: { ConfirmButtons },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            MAX_LONG_FIELD_LENGTH: FIELD_LENGTH.MAX_LONG_FIELD_LENGTH
        };
    },
    computed: {
        ...mapFields([
            'isPackCorrespondsToNeeds',
            'wasAbsent',
            'packQuality',
            'packQualityArguments',
            'packItems',
            'wereIntangibleNeeds',
            'describeIntangibleNeeds'
        ]),
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions']),
        sheetResource () {
            return this.$store.getters['giftGivingReport/getSheetResource'];
        },
        qualityOptions () {
            return this.sheetResource[0].resources;
        }
    }
};
</script>

<style scoped></style>
